import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import FireProtocol from '@/components/FireProtocol'
import FirePrivacy from '@/components/FirePrivacy'
import BossComeProtocol from '@/components/BossComeProtocol'
import BossComePrivacy from '@/components/BossComePrivacy'
import AgentJoinProtocol from '@/components/AgentJoinProtocol'
Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    {
      path: '/AgentJoinProtocol',
      name: 'AgentJoinProtocol',
      component: AgentJoinProtocol
    },
    {
      path: '/BossComeProtocol',
      name: 'BossComeProtocol',
      component: BossComeProtocol
    },
    {
      path: '/BossComePrivacy',
      name: 'BossComePrivacy',
      component: BossComePrivacy
    },
    {
      path: '/FireProtocol',
      name: 'FireProtocol',
      component: FireProtocol
    },
    {
      path: '/FirePrivacy',
      name: 'FirePrivacy',
      component: FirePrivacy
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js